import './style.css';
import { navigate } from './router.js';
import { AuthService } from './services/auth.js';

// Global router listener
window.addEventListener('hashchange', () => {
  navigate();
});

// Listen to Supabase auth changes
AuthService.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_IN') {
    // Si el usuario está en login o no tiene hash, redirigir a dashboard
    // IMPORTANTE: NO re-navegar si el usuario ya está en una vista de la aplicación, ya que Supabase
    // emite el evento 'SIGNED_IN' cada vez que la pestaña/ventana recupera el foco (visibilitychange/refocus).
    if (window.location.hash === '#/login' || !window.location.hash) {
      window.location.hash = '#/dashboard';
    }
  } else if (event === 'SIGNED_OUT') {
    if (window.location.hash !== '#/login') {
      window.location.hash = '#/login';
    } else {
      navigate();
    }
  }
});

// Initial mount (asegurar una única ejecución inicial)
let initialNavigated = false;
function initApp() {
  if (initialNavigated) return;
  initialNavigated = true;
  navigate();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

